/** @format */

import React from 'react';
import Routes from './Routes';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

function App() {
	return (
		<div className='App'>
			<NotificationContainer />
			<Routes />
		</div>
	);
}

export default App;
